import throttle from 'lodash/throttle';
import * as React from 'react';
import { getScrollY } from '~/Utils/scrollPosition';

export function useIsScrollOnTop(element: HTMLElement | string | undefined = undefined) {
    const [isScrollOnTop, setIsScrollOnTop] = React.useState<boolean>(true);
    const onScroll = (scrollableElement: HTMLElement | (Window & typeof globalThis)) => {
        setIsScrollOnTop(getScrollY(scrollableElement) === 0);
    };

    React.useEffect(() => {
        const getScrollableElement = () => {
            if (element === undefined) {
                return window;
            }

            return typeof element === 'string' ? document.getElementById(element) : element;
        };
        const scrollableElement = getScrollableElement();

        if (scrollableElement === null) {
            return;
        }

        const throttledOnScroll = throttle(() => onScroll(scrollableElement), 100);
        scrollableElement.addEventListener('scroll', throttledOnScroll);
        setIsScrollOnTop(getScrollY(scrollableElement) === 0);

        return () => {
            scrollableElement.removeEventListener('scroll', throttledOnScroll);
        };
    }, [element]);

    return { isScrollOnTop };
}
